"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EligibilityCampaignToJSON = exports.EligibilityCampaignFromJSONTyped = exports.EligibilityCampaignFromJSON = exports.instanceOfEligibilityCampaign = void 0;
var EligibilityAdSet_1 = require("./EligibilityAdSet");
var EligibilityCampaignCampaignSchedule_1 = require("./EligibilityCampaignCampaignSchedule");
var HoldoutLevel_1 = require("./HoldoutLevel");
/**
 * Check if a given object implements the EligibilityCampaign interface.
 */
function instanceOfEligibilityCampaign(value) {
    var isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "salesforceOpportunity" in value;
    isInstance = isInstance && "campaignSchedule" in value;
    isInstance = isInstance && "surveySchedule" in value;
    isInstance = isInstance && "markets" in value;
    isInstance = isInstance && "languages" in value;
    isInstance = isInstance && "adSets" in value;
    isInstance = isInstance && "invalidReasons" in value;
    isInstance = isInstance && "holdoutLevel" in value;
    return isInstance;
}
exports.instanceOfEligibilityCampaign = instanceOfEligibilityCampaign;
function EligibilityCampaignFromJSON(json) {
    return EligibilityCampaignFromJSONTyped(json, false);
}
exports.EligibilityCampaignFromJSON = EligibilityCampaignFromJSON;
function EligibilityCampaignFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'salesforceOpportunity': json['salesforce_opportunity'],
        'campaignSchedule': (0, EligibilityCampaignCampaignSchedule_1.EligibilityCampaignCampaignScheduleFromJSON)(json['campaign_schedule']),
        'surveySchedule': (0, EligibilityCampaignCampaignSchedule_1.EligibilityCampaignCampaignScheduleFromJSON)(json['survey_schedule']),
        'markets': json['markets'],
        'languages': json['languages'],
        'adSets': (json['ad_sets'].map(EligibilityAdSet_1.EligibilityAdSetFromJSON)),
        'invalidReasons': json['invalid_reasons'],
        'holdoutLevel': (0, HoldoutLevel_1.HoldoutLevelFromJSON)(json['holdout_level']),
    };
}
exports.EligibilityCampaignFromJSONTyped = EligibilityCampaignFromJSONTyped;
function EligibilityCampaignToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'salesforce_opportunity': value.salesforceOpportunity,
        'campaign_schedule': (0, EligibilityCampaignCampaignSchedule_1.EligibilityCampaignCampaignScheduleToJSON)(value.campaignSchedule),
        'survey_schedule': (0, EligibilityCampaignCampaignSchedule_1.EligibilityCampaignCampaignScheduleToJSON)(value.surveySchedule),
        'markets': value.markets,
        'languages': value.languages,
        'ad_sets': (value.adSets.map(EligibilityAdSet_1.EligibilityAdSetToJSON)),
        'invalid_reasons': value.invalidReasons,
        'holdout_level': (0, HoldoutLevel_1.HoldoutLevelToJSON)(value.holdoutLevel),
    };
}
exports.EligibilityCampaignToJSON = EligibilityCampaignToJSON;
